"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HafTitle = exports.LinkedSiteBlock = exports.LinksBlock = exports.LinkedSite = exports.ExternalLinkIcon = exports.Col = exports.Link = exports.LinkTitle = exports.CopyrightContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const ExternalLinkIcon_1 = require("../../../assets/svg-components/ExternalLinkIcon");
exports.Container = styled_components_1.default.div `
  background: ${props => props.theme.palette.BLUE_GRAY_100};

  padding: ${props => props.theme.spacing.l1}px 0;

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    padding: ${props => props.theme.spacing.m3}px 0;
  }

  @media print {
    display: none;
  }
`;
exports.CopyrightContainer = styled_components_1.default.div `
  padding: ${props => props.theme.spacing.s3}px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${props => props.copyrightInsideContainer
    ? 'flex-direction: column-reverse;'
    : `@media (max-width: ${props.theme.breakpoints.lg}px) {
      flex-direction: column;
      align-items: center;
    }`}

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    padding: ${props => props.theme.spacing.m1}px 0;
  }

  @media print {
    display: none;
  }
`;
exports.LinkTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
`;
exports.Link = styled_components_1.default.a `
  display: inline-block;
  :not(:last-child) {
    margin: 0 0 ${props => (props.first ? props.theme.spacing.s4 : props.theme.spacing.s3)}px 0;
  }
`;
exports.Col = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  ${props => props.descriptionalColumn
    ? `@media (max-width: ${props.theme.breakpoints.xxl}px) {
          margin-top: ${props.theme.spacing.m5}px;
      }
      `
    : null}

  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    &:first-child {
      margin-bottom: ${props => props.theme.spacing.m5}px;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    &:not(:last-child) {
      margin-bottom: ${props => props.theme.spacing.l1}px;
    }
    margin-top: 0;
  }
`;
exports.ExternalLinkIcon = (0, styled_components_1.default)(ExternalLinkIcon_1.ExternalLinkIcon) `
  margin-left: ${props => props.theme.spacing.s1}px;
`;
exports.LinkedSite = styled_components_1.default.a `
  display: flex;
`;
exports.LinksBlock = styled_components_1.default.div `
  display: flex;
  align-items: center;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: column;
    }
  }
`;
exports.LinkedSiteBlock = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    margin-bottom: ${props => props.theme.spacing.s4}px;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    flex-direction: column;
    align-items: center;
  }
`;
exports.HafTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin-right: ${props => props.theme.spacing.s5}px;
  color: ${props => props.theme.palette.BLUE_GRAY_100};
  line-height: ${props => props.theme.spacing.m1}px;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin: 0 0 ${props => props.theme.spacing.s3}px 0;
  }
`;
exports.default = {
    Container: exports.Container,
    LinkTitle: exports.LinkTitle,
    Link: exports.Link,
    Col: exports.Col,
    ExternalLinkIcon: exports.ExternalLinkIcon,
    LinkedSite: exports.LinkedSite,
    LinksBlock: exports.LinksBlock,
    HafTitle: exports.HafTitle
};
